var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContentOrLoading',[(_vm.venta_diaria)?_c('VentaDiariaComponent',{attrs:{"valores":_vm.valores_venta_diaria_grafica}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }